import { hsalsa } from '@noble/ciphers/salsa'

export function assert(x, msg) {
  if (!x) throw new Error(msg || 'Assertion failed')
}

export function assertUint8(arr, size) {
  if (arr instanceof Uint8Array && arr.length === size) return
  throw new Error(`Expected an Uint8Array of size ${Number(size)}`)
}

// input: Uint8Array instance or a hex string
export function toUint8Array(input, size) {
  if (size !== undefined) {
    const result = toUint8Array(input) // convert without size and then re-check
    if (result.length !== size) throw new Error(`expected input if length ${size}`)
    return result
  }
  if (input instanceof Uint8Array) return input
  if (typeof input === 'string') {
    if (input.length % 2 === 0 && /^[0-9a-f]*$/iu.test(input)) return Buffer.from(input, 'hex')
    throw new Error('supplied string is not in hex format')
  }
  throw new Error('expected Uint8Array, Buffer or hex string')
}

// input: Uint8Array instance or an unicode string
export function utf8Buf(input, size) {
  if (size !== undefined) {
    const result = utf8Buf(input) // convert without size and then re-check
    if (result.length !== size) throw new Error(`expected input if length ${size}`)
    return result
  }
  if (input instanceof Uint8Array) return input
  if (typeof input === 'string') return Buffer.from(input, 'utf8')
  throw new Error('expected Uint8Array, Buffer or a string')
}

export const salsaNonceBytes = 24
export const salsaMacBytes = 16

const u32view = (arr) => {
  assert(arr instanceof Uint8Array)
  assert(arr.byteLength % 4 === 0)
  return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4))
}

// Refs: https://github.com/paulmillr/noble-ciphers/issues/35
// Refs: https://github.com/jedisct1/libsodium/blob/master/src/libsodium/crypto_secretbox/crypto_secretbox_easy.c

const sigma32 = Buffer.from('expand 32-byte k')

export function salsaSharedSecret(sharedSecret) {
  const sigma = u32view(new Uint8Array(sigma32)) // clone just in case
  const out = new Uint8Array(32)
  hsalsa(sigma, u32view(sharedSecret), new Uint32Array(16), u32view(out))
  return out
}
